export default function searchAutocomplete() {
    const input = document.getElementById('search-input');
    const dropdown = document.getElementById('search-autocomplete-dropdown');

    if (!input || !dropdown) return;

    const url = input.dataset.autocompleteUrl;
    let debounceTimer = null;

    function closeDropdown() {
        dropdown.classList.add('d-none');
        dropdown.innerHTML = '';
    }

    function renderDropdown(data) {
        const { products, stories } = data;
        if (!products.length && !stories.length) {
            closeDropdown();
            return;
        }

        let html = '';
        if (products.length) {
            products.forEach(p => {
                html += `<li><a href="${p.url}">${p.name}</a></li>`;
            });
        }
        dropdown.innerHTML = html;
        dropdown.classList.remove('d-none');
    }

    input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        const q = this.value.trim();

        if (q.length < 4) {
            closeDropdown();
            return;
        }

        debounceTimer = setTimeout(() => {
            fetch(`${url}?q=${encodeURIComponent(q)}`)
                .then(r => r.json())
                .then(renderDropdown)
                .catch(() => closeDropdown());
        }, 250);
    });

    document.addEventListener('click', function (e) {
        if (!input.contains(e.target) && !dropdown.contains(e.target)) {
            closeDropdown();
        }
    });

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDropdown();
    });
}
